"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.ClassNames = void 0;
exports.ClassNames = {
    icon: 'c-HiddenImageIcon',
    position: {
        center: 'c-HiddenImageIcon-center',
        topLeft: 'c-HiddenImageIcon-left',
        topRight: 'c-HiddenImageIcon-right',
        bottomLeft: 'c-HiddenImageIcon-top',
        bottomRight: 'c-HiddenImageIcon-bottom'
    }
};
exports.Style = (_a = {},
    _a[exports.ClassNames.icon] = {
        'font-size': '36px',
        color: 'white',
        'text-shadow': "0 6px 10px rgba(0, 0, 0, .14),\n             0 1px 18px rgba(0, 0, 0, .12),\n             0 3px 5px rgba(0, 0, 0, .2);",
        position: 'absolute'
    },
    _a[exports.ClassNames.position.center] = {
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    },
    _a[exports.ClassNames.position.topLeft] = {
        top: '0%',
        left: '0%'
    },
    _a[exports.ClassNames.position.topRight] = {
        top: '0%',
        left: '100%',
        transform: 'translate(-100%, 0%)'
    },
    _a[exports.ClassNames.position.bottomLeft] = {
        top: '100%',
        left: '0%',
        transform: 'translate(0%, -100%)'
    },
    _a[exports.ClassNames.position.bottomRight] = {
        top: '100%',
        left: '100%',
        transform: 'translate(-100%, -100%)'
    },
    _a);
//# sourceMappingURL=hidden.image.icon.style.js.map